import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class BookingListQueryFilter extends QueryFilter{
    organizationId: string;
    fromDate: Date;
    toDate: Date;
    hasPaid: boolean;
}